import React from "react";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from "@material-ui/core/Typography";
import {setStatus} from "./OrderItem";
import {withStyles} from "@material-ui/core";
import MuiAccordion from "@material-ui/core/Accordion/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails/AccordionDetails";

const Accordion = withStyles({
    root: {
        border: 'none',
        boxShadow: 'none',
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        borderBottom: 'none',
        minHeight: 40,
        '&$expanded': {
            minHeight: 40,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary);

const Title = withStyles({
    root:{
        width: '100%',
        fontWeight: 500,
        textAlign: 'left',
        fontSize: 16
    }
})(Typography);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails);

export class ContractItem extends React.Component{
    render(){
        const {data} = this.props;
        return(
            <Accordion className={"contract"}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Title className={"title_position"}>{data.name}</Title>
                </AccordionSummary>
                <AccordionDetails >
                    <div style={{width: '100%'}}>
                        <div>
                            {contract_description.map((position, index) => (
                                <div className={"contract_description_field"} key={index}>
                                    <p>{position}</p>
                                    {index !== 1 ?
                                        (<p>{data.info[index]}</p>) :
                                        (<div className={"contract_status " + setStatus(data.info[index])}>
                                            <p>{data.info[index]}</p>
                                        </div>)
                                    }
                                </div>
                            ))}
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>
        )
    }
}
const contract_description = ["Название контракта:", "Статус контракта:", "Город:", "Срок:", "Сумма контракта:", "Комментарий:"];
